<template>
    <div>
        <router-view/>
    </div>
</template>
<script>
  export default {
    mounted(){
      console.log('tools:',this.$route.params.options)
    },
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/pages/tools/tools.vue